/**
 * Recovers query keys hidden by a malformed double-`?` URL. An upstream nginx redirect
 * can concatenate `$args` onto a redirect target that already contains `?`, producing
 * `?key=value?utm_source=...`. Once that URL round-trips through `qs.stringify`, the
 * embedded `?` and `=` get encoded to `%3F` / `%3D` and the contamination becomes
 * `?key=value%3Futm_source%3D...`. This helper splits on either form so `qs.parse`
 * sees the intended `&`-separated pairs.
 *
 * A legitimate `?` in a value is always URL-encoded as `%3F`; we only restore the
 * **first** `%3D` per split segment, so legitimate `=` inside values (e.g. a search
 * query for "a=b") is preserved.
 */
export function normalizeMalformedQuery(q: string): string {
  if (!/\?|%3F/i.test(q))
    return q
  return q
    .split(/\?|%3F/i)
    .map((part, i) => (i === 0 ? part : part.replace(/%3D/i, "=")))
    .join("&")
}
